import { generateEndpoint } from '@ngtrvu/use-api';
import { createApiCall } from 'lib/base';

const GET_FUND_ORDER_RECONCILIATION = 'GET_FUND_ORDER_RECONCILIATION';

const apiCall = createApiCall(
  GET_FUND_ORDER_RECONCILIATION,
  (params: {
    trading_account_manager?: string;
    order_source?: string;
    account_source?: string;
    from_month?: string;
    to_month?: string;
  }) => ({
    endpoint: generateEndpoint({
      host: `api/admin/orders/reconciliation`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
